import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './css/Position.scss'
import Item from './Item'
import OptionalMessage from '../../../../app/components/OptionalMessage'

@injectIntl
export default class Position extends Component {
    static propTypes = {
        position: PropTypes.any,
        services: PropTypes.any,
        order: PropTypes.any,
        intl: intlShape.isRequired,
    }

    // TODO: We should create a TranslationUtil or somthing like that
    translate = (messageId) => {
        if (!this.props.intl.messages[messageId]) {
            return null
        }
        return <FormattedMessage id={messageId}/>
    }

    renderItems = (currentService) => {
        const { position, services, order, ...props } = this.props
        let isSingle = false

        let list = []
        if (currentService.get('mode') === 'service.mode.single') {
            list = [currentService]
            isSingle = true
        } else {
            list = ['service.delivery', 'service.pickup']
            .map(alias => services.find(s => s.get('alias') === alias))
        }

        return list
        .map(service => {
            return (
                <Item
                    key={service.get('id')}
                    order={order}
                    service={service}
                    position={position}
                    isSingle={isSingle}
                    {...props}
                />
            )
        })
    }

    render () {
        const { position, services, order } = this.props
        const currentService = services.get(order.get('service'))
        const name = position.get('alias').split('.').pop()
        const serviceAlias = currentService.get('alias')

        return (
            <div className={styles.position_wrapper}>
                <div className={styles.position}>
                    <div className={styles.meta}>
                        <h4><FormattedMessage id={position.get('alias')}/></h4>
                        <p>{this.translate(`frontend.form_position.hint.product.short.${name}`)}</p>
                        <p>{this.translate(`frontend.form_position.hint.product.${serviceAlias}.${name}`)}</p>
                        <div className={styles.metaContent}>
                            <div>
                                {this.translate(`frontend.form_position.hint.product.volume.${name}`)}
                            </div>
                            <div>
                                {this.translate(`frontend.form_position.hint.product.dimension.${name}`)}
                            </div>
                            <div>
                                {this.translate(`frontend.form_position.hint.product.toner_amount.${name}`)}
                            </div>
                        </div>
                    </div>
                    <div className={styles.items}>
                        {this.renderItems(currentService)}
                    </div>
                </div>
                <div className={styles.position_hint}>
                    <OptionalMessage slug={position.get('alias') + '.hint'} />
                </div>
            </div>
        )
    }
}
